import { Component, computed, HostBinding, inject, Input, signal } from '@angular/core';
import { ToastVariant } from './toast-interface';
import { ToastFacade } from '../../../_core/state/toasts/toast.facade';

@Component({
  selector: 'opac-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  private readonly TOAST_TITLES = {
    info: 'toast.info.title',
    success: 'toast.success.title',
    warning: 'toast.warning.title',
    error: 'toast.error.title',
  };
  private readonly TOAST_ICONS = {
    info: 'info_black',
    success: 'check_black',
    warning: 'alert_black',
    error: 'error_black',
  };

  private readonly toastFacade = inject(ToastFacade);

  readonly icon = computed(() => {
    return this.TOAST_ICONS[this.variant()] ?? 'info';
  })
  readonly variant = signal<ToastVariant>('info');
  readonly title = computed(() => {
    return this.TOAST_TITLES[this.variant()] ?? '';
  });

  @Input() id!: string;

  @HostBinding('class')
  @Input('variant')
  set toastVariant(value: ToastVariant) {
    this.variant.set(value);
  }
  get toastVariant() {
    return this.variant();
  }

  dismiss() {
    this.toastFacade.removeToast(this.id);
  }
}
